export default __webpack_public_path__ + "static/media/Power_Supply.d6527dab.svg";